module.exports = __webpack_public_path__ + "static/media/desktop_hero_allday_break_en.8699608d.jpg";